import React, { useState } from "react";
import {
  EditableTextField,
  EditableSelectField,
  RadioOptions,

} from "../../../../Global_Component/CustomInputComponent";
import { CustomFileUpload,CustomFileUploadLikeSelect } from "../../../../Global_Component/customFileUplodComponent";
import OPTIONS from "../../../../constant/Option";
import { Box, Grid, Typography,Button } from "@mui/material";
import {
  CustomSecondaryButton,
  CustomSuccessButton,
} from "../../../../Global_Component/GlobalButtonComponent";

const COA = () => {
  const [noOfProduct, setNoOfProduct] = useState([
    "SL NO 1",
    "SL NO 2",
    "SL NO 3",

   
   
  ]);

  function addMoreProduct() {
    setNoOfProduct([...noOfProduct, `SL No ${noOfProduct.length + 1}`]);
  }

  return (
    <Box
      sx={{
        maxWidth: "100%",
        margin: "auto",
        padding: "10px",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        backgroundColor: "#fff",
        height: "auto",
      
      }}
    >
      <Typography
        variant="h6"
        sx={{ marginBottom: "20px", fontWeight: "bold", color: "#333" }}
      >
        COA (Certifcate Of analysis)
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          width: "100%",
         
        }}
      >
        <Grid
          container
          spacing={0}
          sx={{ m: 0, p: 0, height: "100%", overflowY: "auto" }}
        >
          {noOfProduct.map((data, index) => (
            <Grid
              container
              key={index}
              sx={{
                borderBottom: "1px solid #ccc", // Optional for row distinction
                p: 1,
                m: 0,
              }}
            >
              <Grid item xs={12} sx={{ p: 0, m: 0 }}>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#313131",
                    fontWeight: 500,
                    lineHeight: 1.5, // Adjust line height
                    p: 0,
                    m: 0,
                  }}
                >
                  {data}
                </Typography>
              </Grid>

              <Grid item md={3.5} sx={{ p: 0.5, m: 0 }}>
                <EditableTextField
                  name="CoaProductName"
                  label="COA Product Name"
                  value=""
                  isEdit={true}
                />
              </Grid>

              <Grid item md={3.5} sx={{ p: 0.5, m: 0 }}>
                <EditableSelectField
                  name="certificateProvider"
                  label="COA certificate Provider"
                  value=""
                  options={[]}
                  isEdit={true}
                />
              </Grid>

              <Grid item md={3.5} sx={{ p: 0.5, m: 0 }}>
                <EditableSelectField
                  name="ManagerOfLab"
                  label="Manager Of Laboratory"
                  value=""
                  options={[]}
                  isEdit={true}
                />
              </Grid>



              <Grid item md={3.5} sx={{ p: 0.5, m: 0 }}>
                <EditableSelectField
                  name="phoneNumberOfManager"
                  label="Contact no Manager of Lab"
                  value=""
                  options={[]}
                  isEdit={true}
                />
              </Grid>

              <Grid item md={3.5} sx={{ p: 0.5, m: 0 }}>
                <CustomFileUploadLikeSelect
                  name="certificate"
                  label="Upload Certificate"
                  value=""
                  onChange={e=>{}}
                  
                />
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Grid
        xs={12}
        container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-stat",
          gap: 1,
          borderTop: "1px solid gray",
        }}
      >
        <Grid md={"10"}>
            <Button onClick={addMoreProduct}>Add more Product</Button>
        </Grid>
        <Grid md={"12"} sx={{ display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 1,
          }}>
        <CustomSecondaryButton label={"Back"} sx={{ margin: 2 }} />
        <CustomSuccessButton label={"Next"} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default COA;
